import React from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import global_es from "../translations/idiom_Es.json";
import global_en from "../translations/idiom_En.json";
import global_por from "../translations/idiom_Por.json";

const CustomTranslatorProvider = ({ children }) => {
  i18next.init({
    interpolation: { escapeValue: false },
    //Ternary to choose based on the location of the browser which language to use
    lng:
      navigator.language.split("-")[0] === "es"
        ? "es"
        : navigator.language.split("-")[0] === "pt"
        ? "por"
        : "en",
    resources: {
      es: {
        global: global_es,
      },
      en: {
        global: global_en,
      },
      por: {
        global: global_por,
      },
    },
  });

  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
};

export default CustomTranslatorProvider;
